module.exports = __webpack_public_path__ + "media/react/components/basic-settings/assets/pre-event-banner-102ce33e4577f33692d780f46cbe7e60.png";